/**
 * Shopify's CDN resizes on demand via `width`. Without it the original upload
 * is served — a 64px tile was pulling a 658KB product shot.
 */
export const shopifyImageUrl = (url: string, width: number): string => {
  if (!url.includes("cdn.shopify.com")) {
    return url;
  }

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}width=${width}`;
};
